// extracted by mini-css-extract-plugin
module.exports = {"controls":"player-PlayerControls__controls--28AYi","btn":"player-PlayerControls__btn--1r-vy","iconInactive":"player-PlayerControls__iconInactive--XqWR7"};